import React, { FC, useContext, useMemo, useState } from 'react'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/label.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/form.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/icon.css'
import '@ta-interaktiv/semantic-ui/semantic/dist/components/divider.css'
import { SearchableMunicipality } from 'types/Municipality'
import styles from './styles.module.scss'
import { LocaleContext } from 'contexts/locale'
import removeAccents from 'remove-accents-diacritics'

interface MunicipalitySearchProps {
  municipalityList: Pick<
    SearchableMunicipality,
    'normalisedName' | 'GemeindeID' | 'Gemeindename' | 'Kanton'
  >[]
  onSelection: (id: string) => void
}

export const MunicipalitySearch: FC<MunicipalitySearchProps> = ({
  municipalityList,
  onSelection
}: MunicipalitySearchProps) => {
  const locale = useContext(LocaleContext)
  const messages = require('./locales/' + locale + '.yml')
  const [searchTerm, setSearchTerm] = useState<string>('')

  const filteredList = useMemo(() => {
    if (searchTerm === '') return []
    const normalisedSearchTerm = removeAccents.remove(searchTerm)

    return municipalityList.filter(municipality =>
      new RegExp(normalisedSearchTerm, 'i').test(municipality.normalisedName)
    )
  }, [searchTerm])

  return (
    <div className={'ui form ' + styles.search}>
      <div className='field'>
        <label htmlFor='municipality-search' className={styles.label}>
          {messages['label']}
        </label>
        <div className='ui icon fluid input'>
          <input
            id='municipality-search'
            className={styles.input}
            placeholder={messages['placeholder']}
            value={searchTerm}
            onChange={event => setSearchTerm(event.target.value)}
          />
          <i className='search icon' />
        </div>
      </div>
      <menu className={styles.results}>
        {filteredList.map((result, index) => (
          <li
            key={result.GemeindeID}
            tabIndex={index}
            onClick={() => {
              setSearchTerm('')
              onSelection(result.GemeindeID)
            }}
            className={styles.result}
          >
            {result.Gemeindename} ({result.Kanton})
          </li>
        ))}
      </menu>
    </div>
  )
}
